import { memo as Memo, useState, useRef, useCallback, useEffect, useMemo } from 'react';

//* HOC's
import withLanguageContext from '@context/consumerHOC/LanguageConsumer';

//* Components
import Checkbox from '../Checkbox';
import CustomCollapse from '@/components/global/CustomCollapse';
import Text from '@/components/global/Text';

const DropdownCheckbox = Memo(({ placeholder, onChange, ...props }) => {
	//! States
	const [isOpened, setIsOpened] = useState(false);
	const [count, setCount] = useState(0);

	//! Refs
	const selectValRef = useRef();
	const selectListContRef = useRef();

	//! Toggle Select
	const toggleSelectBox = useCallback(() => {
		setIsOpened(!isOpened);
	}, [isOpened]);

	//! Handle Click
	const handleClick = (e) => {
		if (!selectValRef.current.contains(e.target) && !selectListContRef.current.contains(e.target) && isOpened) {
			toggleSelectBox();
		}
	};

	//! Click Event Listener
	useEffect(() => {
		document.addEventListener('mousedown', handleClick);

		return () => {
			document.removeEventListener('mousedown', handleClick);
		};
	});

	//! Selected Value HTML
	const selectedValueHTML = useMemo(() => {
		return (
			<div
				ref={selectValRef}
				onClick={toggleSelectBox}
				className={`dcheckbox-val ${placeholder ? 'placeholder' : ''}`}>
				{props.leftIcon && (typeof props.leftIcon === 'string' ? <i className={`dcheckbox-left-icon ${props.leftIcon}`} /> : <i className={`dcheckbox-left-icon`}>{props.leftIcon}</i>)}

				{(placeholder && props.translate(placeholder) + (props.required ? '*' : '')) || ''}

				<Text
					tag={'span'}
					className='dcheckbox-count'>
					{count}
				</Text>

				<i className={`dcheckbox-icon ${props.icon || 'ma-arrow-down'}`} />
			</div>
		);
	}, [placeholder, isOpened, count]);

	//! On Change
	const onValueChange = (name, val) => {
		// !unmount && setUnmount(true)
		setCount(val.length);
		onChange && onChange(name, val);
	};

	//! Getting Child Props
	const { className, listClassName, fullWidth, ...childProps } = props;

	//! Setting Style for Full Width List Container
	const listContStyle = useMemo(() => {
		let domRect = selectValRef.current && selectValRef.current.getBoundingClientRect();

		if (props.fullWidth && domRect) {
			return { left: -domRect.x + 'px' };
		}
	}, [props.fullWidth, selectValRef.current]);

	return (
		<div className={`dcheckbox-cont custom-dcheckbox-cont ${props.className || ''} ${props.errorMsg ? 'error' : ''} ${isOpened ? 'dcheckbox-opened' : ''} ${props.leftIcon ? 'with-left-icon' : ''}`}>
			{selectedValueHTML}

			<div
				style={listContStyle}
				ref={selectListContRef}
				className={`list-items ${props.fullWidth ? 'full-width' : ''}`}>
				<div className={`dcheckbox-list ${props.listClassName || ''}`}>
					<CustomCollapse isCollapsed={isOpened}>
						<Checkbox
							type='checkbox'
							isOpened={isOpened}
							onChange={onValueChange}
							{...childProps}
						/>
					</CustomCollapse>
				</div>
			</div>
		</div>
	);
});

export default withLanguageContext(DropdownCheckbox, ['translate']);
